import { createFileRoute } from "@tanstack/react-router";
import { FormRulesTabPanel } from "@/features/form-editor/components/form-rules-tab-panel";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/ticketTypes/$ticketTypeId/form/rules",
)({
	component: FormRulesTabPanel,
});
